export default __webpack_public_path__ + "static/media/4.ee74c6b0.jpg";